/**
 * Copyright 2026 Google LLC.
 * Copyright (c) Microsoft Corporation.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * THIS FILE IS AUTOGENERATED by cddlconv 0.2.0.
 * Run `tools/update_bidi_types.py` to regenerate.
 * @see https://github.com/w3c/webdriver-bidi/blob/master/index.bs
 */

import * as z from 'zod';

export namespace Speculation {
  export const PreloadingStatusSchema: z.ZodLazy<
    z.ZodEnum<{
      pending: 'pending';
      ready: 'ready';
      success: 'success';
      failure: 'failure';
    }>
  > = z.lazy(() => z.enum(['pending', 'ready', 'success', 'failure']));
}
export const SpeculationEventSchema: z.ZodLazy<
  typeof Speculation.PrefetchStatusUpdatedSchema
> = z.lazy(() => Speculation.PrefetchStatusUpdatedSchema);
export namespace Speculation {
  export const PrefetchStatusUpdatedSchema: z.ZodLazy<
    z.ZodObject<{
      method: z.ZodLiteral<'speculation.prefetchStatusUpdated'>;
      params: typeof Speculation.PrefetchStatusUpdatedParametersSchema;
    }>
  > = z.lazy(() =>
    z.object({
      method: z.literal('speculation.prefetchStatusUpdated'),
      params: Speculation.PrefetchStatusUpdatedParametersSchema,
    }),
  );
}
export namespace Speculation {
  export const PrefetchStatusUpdatedParametersSchema: z.ZodLazy<
    z.ZodObject<{
      context: z.ZodString;
      url: z.ZodString;
      status: typeof Speculation.PreloadingStatusSchema;
    }>
  > = z.lazy(() =>
    z.object({
      context: z.string(),
      url: z.string(),
      status: Speculation.PreloadingStatusSchema,
    }),
  );
}
